/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDiyPage {
  pageHeading?: string;
  pageImage?: string;
  pageText?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class DiyActivity extends Component {
  private readonly diyPage: IDiyPage = {
    pageHeading: 'LEGO photo frame',
    pageImage:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxPe',
    pageText:
      'They’ve spent all day perfecting their LEGO masterpiece, and by tomorrow it might be something completely different—so use this unique frame to showcase and preserve their latest LEGO creation! Encourage their creativity with a play keepsake that can be displayed in their bedroom or around the house.',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.diyPage.pageHeading}</h1>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-image'>
              <img
                className='img-responsive'
                src={this.diyPage.pageImage}
                alt={this.diyPage.pageHeading}
              />
            </div>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-text'>
              <p>{this.diyPage.pageText}</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DiyActivity;
